/* ============================================================
   mobileCasez — reskin interaction engine
   Vanilla JS. No dependencies. Wires the ported design to the
   real Shopify cart (AJAX + Section Rendering API).
   ============================================================ */
(function () {
  'use strict';

  var CART_SECTION = 'mcz-cart-drawer';

  /* -------- tiny helpers -------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); }

  /* -------- money (Shopify format) -------- */
  function formatMoney(cents) {
    var fmt = window.mczMoneyFormat || '&#8377;{{amount}}';
    cents = typeof cents === 'string' ? cents.replace('.', '') : cents;
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var match = fmt.match(placeholder);
    switch (match && match[1]) {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  window.mczFormatMoney = formatMoney;

  /* ===========================================================
     1) HOVER ENGINE — honours the design's `style-hover` attribute
     =========================================================== */
  function parseStyle(str) {
    var out = {};
    (str || '').split(';').forEach(function (d) {
      var i = d.indexOf(':');
      if (i > -1) {
        var prop = d.slice(0, i).trim();
        var val = d.slice(i + 1).trim();
        if (prop) out[prop] = val;
      }
    });
    return out;
  }
  function initHover(root) {
    $all('[style-hover]', root).forEach(function (el) {
      if (el.__mczHover) return;
      el.__mczHover = true;
      var hover = parseStyle(el.getAttribute('style-hover'));
      var props = Object.keys(hover);
      if (!props.length) return;
      var enter = function () {
        el.__mczPrev = {};
        props.forEach(function (p) {
          el.__mczPrev[p] = el.style.getPropertyValue(p);
          el.style.setProperty(p, hover[p]);
        });
      };
      var leave = function () {
        if (!el.__mczPrev) return;
        props.forEach(function (p) {
          if (el.__mczPrev[p]) el.style.setProperty(p, el.__mczPrev[p]);
          else el.style.removeProperty(p);
        });
      };
      on(el, 'mouseenter', enter);
      on(el, 'mouseleave', leave);
      on(el, 'focus', enter);
      on(el, 'blur', leave);
    });
  }

  /* ===========================================================
     2) CART — real Shopify AJAX + Section Rendering API
     =========================================================== */
  function updateCounts(count) {
    $all('[data-mcz-cart-count]').forEach(function (n) { n.textContent = count; });
  }
  function refreshDrawer(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-mcz-cart-root]');
    var current = $('[data-mcz-cart-root]');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      var c = fresh.getAttribute('data-cart-count');
      if (c != null) updateCounts(c);
      initHover(current);
    }
  }
  function cartRequest(url, body) {
    body.sections = CART_SECTION;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function openCart() { toggleOverlay('mcz-cart', true); }
  function closeCart() { toggleOverlay('mcz-cart', false); }

  function addToCart(variantId, qty, opts) {
    opts = opts || {};
    if (!variantId) return;
    return cartRequest('/cart/add.js', { items: [{ id: variantId, quantity: qty || 1 }] })
      .then(function (data) {
        if (data && data.status) { // error object
          mczToast(data.description || 'Could not add to cart');
          return;
        }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCounts(cart.item_count);
          return renderDrawerFromApi().then(function () {
            if (opts.silent !== true) { openCart(); }
            mczToast('✦ Added — ' + (opts.name || (data.items && data.items[0] && data.items[0].product_title) || 'item'));
          });
        });
      })
      .catch(function () { mczToast('Network error — try again'); });
  }
  function changeLine(key, qty) {
    return cartRequest('/cart/change.js', { id: key, quantity: qty })
      .then(function (data) {
        updateCounts(data.item_count);
        return renderDrawerFromApi();
      });
  }
  // Re-render the drawer section via the Section Rendering API
  function renderDrawerFromApi() {
    return fetch('/?sections=' + CART_SECTION)
      .then(function (r) { return r.json(); })
      .then(function (json) { refreshDrawer(json[CART_SECTION]); })
      .catch(function () {});
  }

  function initCart(root) {
    // openers / closers
    $all('[data-mcz-open-cart]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); openCart(); }); });
    $all('[data-mcz-close-cart]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); closeCart(); }); });

    // event-delegated quick-add + line controls (survive drawer re-render)
    if (!document.__mczCartDelegated) {
      document.__mczCartDelegated = true;
      document.addEventListener('click', function (e) {
        var add = e.target.closest && e.target.closest('[data-mcz-add]');
        if (add) {
          e.preventDefault();
          addToCart(add.getAttribute('data-variant'), parseInt(add.getAttribute('data-qty') || '1', 10), { name: add.getAttribute('data-name') });
          return;
        }
        var inc = e.target.closest && e.target.closest('[data-mcz-line-inc]');
        var dec = e.target.closest && e.target.closest('[data-mcz-line-dec]');
        var rm = e.target.closest && e.target.closest('[data-mcz-line-remove]');
        var node = inc || dec || rm;
        if (node) {
          e.preventDefault();
          var line = node.getAttribute('data-key');
          var cur = parseInt(node.getAttribute('data-qty') || '1', 10);
          if (inc) changeLine(line, cur + 1);
          else if (dec) changeLine(line, Math.max(0, cur - 1));
          else changeLine(line, 0);
        }
      });
    }
  }

  /* ===========================================================
     3) OVERLAYS (cart / menu / deal / toast)
     =========================================================== */
  function toggleOverlay(id, open) {
    var el = document.getElementById(id);
    if (!el) return;
    if (open) { el.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    else {
      el.classList.remove('is-open');
      // only unlock if no other overlay open
      if (!$('.mcz-overlay.is-open')) document.documentElement.style.overflow = '';
    }
    // Hide floating UI (mobile add-to-cart bar, back-to-top) while any drawer or
    // overlay is open, so it can't cover the drawer's controls — e.g. Checkout.
    document.body.classList.toggle('mcz-overlay-open', !!$('.mcz-overlay.is-open'));
  }
  window.mczToggleOverlay = toggleOverlay;

  function initMenu(root) {
    $all('[data-mcz-open-menu]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); toggleOverlay('mcz-menu', true); }); });
    $all('[data-mcz-close-menu]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); toggleOverlay('mcz-menu', false); }); });
    $all('#mcz-menu a').forEach(function (a) { on(a, 'click', function () { toggleOverlay('mcz-menu', false); }); });
  }

  var toastTimer;
  function mczToast(msg) {
    var host = $('[data-mcz-toast]');
    if (!host) return;
    host.textContent = msg;
    host.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { host.classList.remove('is-open'); }, 2200);
  }
  window.mczToast = mczToast;

  function initDeal(root) {
    var deal = document.getElementById('mcz-deal');
    if (!deal || deal.__mcz) return; deal.__mcz = true;
    var dlyRaw = parseFloat(deal.getAttribute('data-delay'));
    var adsRaw = parseFloat(deal.getAttribute('data-ads-delay'));
    var cfg = {
      freq: deal.getAttribute('data-freq') || 'session',           // page | session | day
      delay: (isNaN(dlyRaw) ? 3 : dlyRaw) * 1000,                  // 0 is a valid "instant"
      tmode: deal.getAttribute('data-timer-mode') || 'evergreen',  // evergreen | fixed
      mins: parseInt(deal.getAttribute('data-minutes') || '15', 10),
      end: deal.getAttribute('data-end') || '',
      hideExpired: deal.getAttribute('data-hide-expired') !== 'false',
      design: deal.getAttribute('data-design-mode') === 'true',
      ads: deal.getAttribute('data-ads') !== 'false',              // auto-open for paid-ad landings too
      adsDelay: (isNaN(adsRaw) ? 1 : adsRaw) * 1000,               // ad visitors decide fast — show sooner
      autoApply: deal.getAttribute('data-auto-apply') !== 'false', // set the discount cookie on view
      code: deal.getAttribute('data-code') || '',
      maxOpens: parseInt(deal.getAttribute('data-max-opens') || '2', 10)
    };

    // ---- countdown deadline ----
    // fixed mode: only a real, merchant-set end date produces a timer.
    // evergreen mode: one deadline per session; an expired deadline is NEVER
    // re-minted (no perpetually-restarting fake urgency).
    var deadline = null;
    if (cfg.tmode === 'fixed') {
      if (cfg.end) {
        var d = new Date(cfg.end.replace(' ', 'T'));
        if (!isNaN(d.getTime())) deadline = d.getTime();
      }
      // blank/invalid end date -> no timer at all
    } else { // evergreen
      var stored = null;
      try { var s = sessionStorage.getItem('mcz-deal-deadline'); if (s) stored = parseInt(s, 10); } catch (e) {}
      if (stored) {
        deadline = stored; // keep it, even if already expired
      } else {
        deadline = Date.now() + cfg.mins * 60000;
        try { sessionStorage.setItem('mcz-deal-deadline', '' + deadline); } catch (e) {}
      }
    }
    var hasTimer = deadline !== null;
    var twrap = $('[data-mcz-t-wrap]', deal);
    if (!hasTimer && twrap) twrap.style.display = 'none';
    function expired() { return hasTimer && deadline - Date.now() <= 0; }

    // ---- frequency gate ----
    function seen() {
      try {
        if (cfg.freq === 'session') return !!sessionStorage.getItem('mcz-deal-seen');
        if (cfg.freq === 'day') return localStorage.getItem('mcz-deal-day') === new Date().toDateString();
      } catch (e) {}
      return false; // 'page' → show on every page view
    }
    function markSeen() {
      try {
        sessionStorage.setItem('mcz-deal-seen', '1');
        localStorage.setItem('mcz-deal-day', new Date().toDateString());
      } catch (e) {}
    }
    // auto-open cap per session: an accidental scrim tap doesn't bury the offer,
    // but it never nags past maxOpens either. Explicit close (× / Later) = markSeen.
    function opens() { try { return parseInt(sessionStorage.getItem('mcz-deal-opens') || '0', 10) || 0; } catch (e) { return 0; } }
    function bumpOpens() { try { sessionStorage.setItem('mcz-deal-opens', '' + (opens() + 1)); } catch (e) {} }
    // one-shot discount cookie so the code is already applied at checkout
    function autoApply() {
      if (!cfg.autoApply || !cfg.code) return;
      try {
        if (sessionStorage.getItem('mcz-deal-applied') === cfg.code) { setBarApplied(); return; }
        sessionStorage.setItem('mcz-deal-applied', cfg.code);
      } catch (e) {}
      mczApplyDiscount(cfg.code);
      setBarApplied();
    }

    // ---- timer rendering ----
    var tick;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function renderTimer() {
      var ms = Math.max(0, deadline - Date.now());
      var dd = Math.floor(ms / 86400000);
      var hh = Math.floor(ms / 3600000) % 24;
      var mm = Math.floor(ms / 60000) % 60;
      var ss = Math.floor(ms / 1000) % 60;
      var eD = $('[data-mcz-t-d]', deal), eH = $('[data-mcz-t-h]', deal), eM = $('[data-mcz-t-m]', deal), eS = $('[data-mcz-t-s]', deal);
      if (eD) { eD.textContent = pad(dd); var b = eD.closest('[data-mcz-t-box]'); if (b) b.style.display = dd > 0 ? '' : 'none'; }
      if (eH) eH.textContent = pad(hh);
      if (eM) eM.textContent = pad(mm);
      if (eS) eS.textContent = pad(ss);
      if (ms <= 0) {
        clearInterval(tick);
        if (cfg.hideExpired && !cfg.design) { toggleOverlay('mcz-deal', false); if (bar) bar.style.display = 'none'; }
      }
    }
    function openDeal() {
      if (expired() && cfg.hideExpired && !cfg.design) return;
      toggleOverlay('mcz-deal', true);
      if (!cfg.design) { bumpOpens(); autoApply(); } // "seen" is marked on explicit close, not on open
      if (hasTimer) {
        renderTimer();
        clearInterval(tick);
        tick = setInterval(renderTimer, 1000);
      }
    }

    // ---- closers ----
    $all('[data-mcz-close-deal]', deal).forEach(function (b) {
      on(b, 'click', function (e) { e.preventDefault(); toggleOverlay('mcz-deal', false); clearInterval(tick); if (!cfg.design) markSeen(); });
    });

    // ---- click-to-copy coupon ----
    function copyText(code, cb) {
      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        ta.remove();
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(cb, function () { fallback(); cb(); });
      } else { fallback(); cb(); }
    }
    function flashCopied() {
      var state = $('[data-mcz-copy-state]', deal);
      if (!state) return;
      var prev = state.getAttribute('data-idle') || state.textContent;
      state.setAttribute('data-idle', prev);
      state.textContent = 'Copied & applied ✓';
      setTimeout(function () { state.textContent = prev; }, 2400);
    }
    function applyCode(code) {
      mczApplyDiscount(code);
      try { sessionStorage.setItem('mcz-deal-applied', code); } catch (e) {}
      setBarApplied();
      if (!cfg.design) markSeen(); // they took the code — no need to auto-open again
    }
    var coupon = $('[data-mcz-coupon]', deal);
    on(coupon, 'click', function () {
      var code = coupon.getAttribute('data-code') || cfg.code;
      copyText(code, function () { applyCode(code); flashCopied(); });
    });

    // ---- always-visible coupon bar: survives any dismissal, so the offer is never lost ----
    var bar = document.getElementById('mcz-deal-bar');
    function setBarApplied() {
      var t = bar && bar.querySelector('[data-mcz-bar-cta]');
      if (t) t.textContent = t.getAttribute('data-applied') || 'Applied ✓';
    }
    if (bar && !bar.__mcz) {
      bar.__mcz = true;
      var minK = 'mcz-deal-bar-min';
      var setMin = function (m) { bar.classList.toggle('is-min', !!m); try { sessionStorage.setItem(minK, m ? '1' : ''); } catch (e) {} };
      try { if (sessionStorage.getItem(minK)) bar.classList.add('is-min'); } catch (e) {}
      on(bar.querySelector('[data-mcz-bar-min]'), 'click', function (e) { e.stopPropagation(); e.preventDefault(); setMin(true); });
      var barTap = function () {
        if (bar.classList.contains('is-min')) { setMin(false); return; }
        var code = bar.getAttribute('data-code') || cfg.code;
        if (code) copyText(code, function () { applyCode(code); flashCopied(); });
        openDeal();
      };
      on(bar, 'click', barTap);
      on(bar, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); barTap(); } });
      if (expired() && cfg.hideExpired && !cfg.design) bar.style.display = 'none';
    }

    // ---- schedule ----
    // Paid-ad landings (gclid & co.) are the highest-intent visitors, so the offer
    // shows for them too (merchant toggle) — a little sooner, since they decide fast.
    // The session is never "poisoned": a visitor who hasn't explicitly closed the
    // popup can still get it on a later page, up to maxOpens.
    var adLanding = /[?&](gclid|gbraid|wbraid|msclkid|fbclid|ttclid)=/i.test(window.location.search);
    if (cfg.design) {
      setTimeout(openDeal, 400);
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.contains && e.target.contains(deal)) openDeal();
      });
    } else {
      autoApply(); // discount is live at checkout even if the popup is never opened
      var live = !(expired() && cfg.hideExpired);
      if (adLanding && cfg.ads) {
        // An ad click is a fresh landing: ALWAYS lead with the popup, whatever this
        // session saw before (stale flags from older code, earlier caps, an explicit
        // close on a previous visit). The coupon bar still persists after it closes.
        try { sessionStorage.removeItem('mcz-deal-seen'); sessionStorage.setItem('mcz-deal-opens', '0'); } catch (e) {}
        if (live) deal.__mczTimer = setTimeout(openDeal, cfg.adsDelay);
      } else if (!adLanding && !seen() && opens() < cfg.maxOpens && live) {
        deal.__mczTimer = setTimeout(openDeal, cfg.delay);
      }
    }
  }

  // click on a scrim closes its overlay
  function initScrims() {
    if (document.__mczScrims) return; document.__mczScrims = true;
    $all('[data-mcz-scrim]').forEach(function (s) {
      on(s, 'click', function () {
        var ov = s.closest('.mcz-overlay');
        if (ov) toggleOverlay(ov.id, false);
      });
    });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') { var o = $('.mcz-overlay.is-open'); if (o) toggleOverlay(o.id, false); }
    });
  }

  /* ===========================================================
     4) CAMPAIGN CAROUSEL
     =========================================================== */
  function initCarousels(root) {
    $all('[data-mcz-carousel]', root).forEach(function (car) {
      if (car.__mcz) return; car.__mcz = true;
      var track = $('[data-mcz-track]', car);
      var slides = track ? $all(':scope > *', track) : [];
      // controls (arrows/dots) live in the section header/footer, OUTSIDE the
      // carousel box — scope lookups to the enclosing section
      var scope = car.closest('section') || car.closest('.shopify-section') || car;
      var dots = $all('[data-mcz-dot]', scope);
      var n = slides.length;
      if (!track || n < 2) return;
      var idx = 0, paused = false;
      var auto = car.getAttribute('data-autorotate') !== 'false';
      function go(i) {
        idx = (i + n) % n;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        dots.forEach(function (d, di) {
          d.style.background = di === idx ? 'var(--accent,#D8FF3E)' : 'rgba(20,21,26,.14)';
        });
      }
      $all('[data-mcz-prev]', scope).forEach(function (b) { on(b, 'click', function () { go(idx - 1); }); });
      $all('[data-mcz-next]', scope).forEach(function (b) { on(b, 'click', function () { go(idx + 1); }); });
      dots.forEach(function (d, di) { on(d, 'click', function () { go(di); }); });
      on(car, 'mouseenter', function () { paused = true; });
      on(car, 'mouseleave', function () { paused = false; });
      // touch swipe for mobile
      var swipeX = null;
      on(track, 'touchstart', function (e) { swipeX = e.touches[0].clientX; paused = true; }, { passive: true });
      on(track, 'touchend', function (e) {
        if (swipeX === null) return;
        var dx = e.changedTouches[0].clientX - swipeX;
        swipeX = null; paused = false;
        if (Math.abs(dx) > 40) { if (dx < 0) go(idx + 1); else go(idx - 1); }
      }, { passive: true });
      go(0);
      if (auto) {
        setInterval(function () {
          if (!paused && !document.hidden && !(window.Shopify && window.Shopify.designMode)) go(idx + 1);
        }, 5000);
      }
    });
  }

  // On mobile, the campaign slider section moves ABOVE the hero (design spec);
  // desktop keeps the authored order. Sections are siblings inside MainContent.
  function initMobileOrder() {
    var car = $('[data-mcz-carousel]');
    var hero = $('[data-mcz-hero]');
    if (!car || !hero) return;
    var carSec = car.closest('.shopify-section');
    var heroSec = hero.closest('.shopify-section');
    if (!carSec || !heroSec || carSec === heroSec || carSec.parentElement !== heroSec.parentElement) return;
    if (heroSec.__mczOrder) return; heroSec.__mczOrder = true;
    var mq = window.matchMedia('(max-width: 860px)');
    function apply() {
      if (mq.matches) heroSec.parentElement.insertBefore(carSec, heroSec);
      else heroSec.parentElement.insertBefore(heroSec, carSec);
    }
    if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
    apply();
  }

  /* ===========================================================
     5) SCROLL REVEAL + HERO TILT
     =========================================================== */
  function initReveal(root) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = $all('[data-reveal]', root);
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.style.opacity = '1'; }); return; }
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { en.target.style.opacity = '1'; en.target.style.transform = 'none'; io.unobserve(en.target); }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) {
      if (el.__mczR) return; el.__mczR = true;
      if (el.getBoundingClientRect().top > vh * 0.92) {
        el.style.opacity = '0'; el.style.transform = 'translateY(26px)';
        el.style.transition = 'opacity .7s ease, transform .7s ease';
        io.observe(el);
      }
    });
  }
  function initTilt(root) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    $all('[data-tilt]', root).forEach(function (el) {
      if (el.__mczT) return; el.__mczT = true;
      on(el, 'mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * 7).toFixed(2) + 'deg) rotateX(' + (-y * 7).toFixed(2) + 'deg)';
      });
      on(el, 'mouseleave', function () { el.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg)'; });
    });
  }

  /* ===========================================================
     6) PRODUCT PAGE
     =========================================================== */
  function initPDP(root) {
    $all('[data-mcz-pdp]', root).forEach(function (pdp) {
      if (pdp.__mcz) return; pdp.__mcz = true;

      // sticky add-to-cart bar (mobile) — mirrors the main button
      var sticky = document.querySelector('[data-mcz-sticky]');
      var mainAtc = $('[data-mcz-atc]', pdp);
      if (sticky && mainAtc) {
        var stickyBtn = sticky.querySelector('[data-mcz-sticky-add]');
        var stickyPrice = sticky.querySelector('[data-mcz-sticky-price]');
        var unitPrice = $('[data-mcz-price]', pdp);
        // sticky quantity mirrors the main quantity stepper (both directions)
        var mainQtyInc = $('[data-mcz-qty-inc]', pdp);
        var mainQtyDec = $('[data-mcz-qty-dec]', pdp);
        var mainQtyVal = $('[data-mcz-qty-val]', pdp);
        var stickyQty = sticky.querySelector('[data-mcz-sticky-qty]');
        var stickyInc = sticky.querySelector('[data-mcz-sticky-inc]');
        var stickyDec = sticky.querySelector('[data-mcz-sticky-dec]');
        function syncQty() { if (stickyQty && mainQtyVal) stickyQty.textContent = mainQtyVal.textContent; }
        if (stickyInc && mainQtyInc) on(stickyInc, 'click', function () { mainQtyInc.click(); syncQty(); });
        if (stickyDec && mainQtyDec) on(stickyDec, 'click', function () { mainQtyDec.click(); syncQty(); });
        if (stickyBtn) on(stickyBtn, 'click', function () { mainAtc.click(); });
        function syncPrice() { if (stickyPrice && unitPrice) stickyPrice.textContent = unitPrice.textContent; }
        syncQty();
        // publish the sticky bar's height so other floating UI (deal bar) sits above it
        function stickyState(onScreen) {
          var visible = onScreen && window.getComputedStyle(sticky).display !== 'none';
          document.body.classList.toggle('mcz-sticky-on', visible);
          document.documentElement.style.setProperty('--mcz-sticky-h', visible ? sticky.offsetHeight + 'px' : '0px');
        }
        var show = false;
        function toggle() {
          var r = mainAtc.getBoundingClientRect();
          var past = r.bottom < 0 || r.top > (window.innerHeight || 0);
          if (past !== show) { show = past; sticky.hidden = !past; sticky.style.display = past ? 'flex' : 'none'; syncPrice(); syncQty(); stickyState(past); }
        }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (e) {
            var vis = e[0].isIntersecting;
            sticky.hidden = vis; sticky.style.display = vis ? 'none' : 'flex'; if (!vis) { syncPrice(); syncQty(); } stickyState(!vis);
          }, { rootMargin: '0px' }).observe(mainAtc);
        } else {
          on(window, 'scroll', toggle, { passive: true }); toggle();
        }
        pdp.addEventListener('change', function () { syncPrice(); syncQty(); });
        pdp.addEventListener('click', function () { setTimeout(function () { syncPrice(); syncQty(); }, 30); });
      }

      // gallery
      var mainImg = $('[data-mcz-main-img]', pdp);
      $all('[data-mcz-thumb]', pdp).forEach(function (t) {
        on(t, 'click', function () {
          var src = t.getAttribute('data-src');
          if (mainImg && src) mainImg.src = src;
          $all('[data-mcz-thumb]', pdp).forEach(function (o) { o.style.borderColor = 'transparent'; });
          t.style.borderColor = 'var(--accent-deep,#6B7F0E)';
        });
      });

      // variants
      var variants = [];
      try { variants = JSON.parse(($('[data-mcz-variants]', pdp) || {}).textContent || '[]'); } catch (e) {}
      var current = variants.filter(function (v) { return v.available; })[0] || variants[0] || null;
      var selected = {};
      var atc = $('[data-mcz-atc]', pdp);

      function findVariant() {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return selected[i] == null || selected[i] === o; });
        });
      }
      function priceCents() { return current ? current.price : 0; }
      function refresh() {
        var qty = getQty();
        var priceEl = $('[data-mcz-price]', pdp);
        var mrpEl = $('[data-mcz-mrp]', pdp);
        if (current && priceEl) priceEl.innerHTML = formatMoney(current.price);
        if (current && mrpEl) { if (current.compare > current.price) { mrpEl.innerHTML = formatMoney(current.compare); mrpEl.style.display = ''; } else { mrpEl.style.display = 'none'; } }
        if (atc) {
          if (current && current.available) {
            atc.removeAttribute('disabled');
            atc.style.opacity = '';
            atc.setAttribute('data-variant', current.id);
            atc.setAttribute('data-qty', qty);
            var lbl = $('[data-mcz-atc-label]', atc);
            if (lbl) lbl.textContent = atc.getAttribute('data-label') || 'Add to cart';
          } else {
            atc.setAttribute('disabled', 'disabled');
            atc.style.opacity = '.5';
            var lbl2 = $('[data-mcz-atc-label]', atc);
            if (lbl2) lbl2.textContent = current ? 'Sold out' : 'Unavailable';
          }
        }
      }
      // option pickers
      $all('[data-mcz-option]', pdp).forEach(function (picker) {
        var oi = parseInt(picker.getAttribute('data-mcz-option'), 10);
        $all('[data-mcz-value]', picker).forEach(function (btn) {
          on(btn, 'click', function () {
            selected[oi] = btn.getAttribute('data-mcz-value');
            $all('[data-mcz-value]', picker).forEach(function (o) { o.setAttribute('data-active', 'false'); });
            btn.setAttribute('data-active', 'true');
            current = findVariant() || null;
            refresh();
          });
        });
      });

      // qty
      var qtyVal = $('[data-mcz-qty-val]', pdp);
      function getQty() { return qtyVal ? parseInt(qtyVal.textContent || '1', 10) : 1; }
      function setQty(q) { q = Math.max(1, q); if (qtyVal) qtyVal.textContent = q; refresh(); }
      on($('[data-mcz-qty-inc]', pdp), 'click', function () { setQty(getQty() + 1); });
      on($('[data-mcz-qty-dec]', pdp), 'click', function () { setQty(getQty() - 1); });

      // add to cart
      on(atc, 'click', function (e) {
        e.preventDefault();
        if (!current || !current.available) return;
        addToCart(current.id, getQty(), { name: pdp.getAttribute('data-name') });
      });

      refresh();
    });
  }

  /* ===========================================================
     7) COLLECTION filter + sort (client-side over rendered cards)
     =========================================================== */
  function initCollection(root) {
    $all('[data-mcz-collection]', root).forEach(function (col) {
      if (col.hasAttribute('data-mcz-facets')) return; // mcz-filters.js owns it
      if (col.__mcz) return; col.__mcz = true;
      var grid = $('[data-mcz-grid]', col);
      if (!grid) return;
      var cards = $all('[data-mcz-card]', grid);
      var promo = $('[data-mcz-promo]', grid);
      var noRes = $('[data-mcz-empty]', col);
      var shownLabel = $('[data-mcz-shown]', col);
      var brand = 'all';
      var sort = 'featured';

      function apply() {
        var visible = 0;
        cards.forEach(function (c) {
          var b = (c.getAttribute('data-brand') || '').toLowerCase();
          var match = brand === 'all' || b === brand;
          c.style.display = match ? '' : 'none';
          if (match) visible++;
        });
        // sort visible
        var arr = cards.filter(function (c) { return c.style.display !== 'none'; });
        arr.sort(function (a, b) {
          if (sort === 'price-asc') return num(a, 'price') - num(b, 'price');
          if (sort === 'price-desc') return num(b, 'price') - num(a, 'price');
          if (sort === 'rating') return num(b, 'rating') - num(a, 'rating');
          return num(a, 'order') - num(b, 'order');
        });
        arr.forEach(function (c) { grid.insertBefore(c, promo || null); });
        if (promo) grid.appendChild(promo);
        if (noRes) noRes.style.display = visible ? 'none' : '';
        if (grid) grid.style.display = visible ? 'grid' : 'none';
        if (shownLabel) shownLabel.textContent = visible + (visible === 1 ? ' case' : ' cases');
        var clear = $('[data-mcz-clear]', col);
        if (clear) clear.style.display = brand === 'all' ? 'none' : '';
      }
      function num(c, key) { return parseFloat(c.getAttribute('data-' + key) || '0'); }

      $all('[data-mcz-filter]', col).forEach(function (chip) {
        on(chip, 'click', function () {
          brand = (chip.getAttribute('data-mcz-filter') || 'all').toLowerCase();
          $all('[data-mcz-filter]', col).forEach(function (o) { o.setAttribute('data-active', 'false'); });
          chip.setAttribute('data-active', 'true');
          apply();
        });
      });
      $all('[data-mcz-clear]', col).forEach(function (b) {
        on(b, 'click', function () {
          brand = 'all';
          $all('[data-mcz-filter]', col).forEach(function (o) { o.setAttribute('data-active', o.getAttribute('data-mcz-filter') === 'all' ? 'true' : 'false'); });
          apply();
        });
      });
      var sel = $('[data-mcz-sort]', col);
      on(sel, 'change', function () { sort = sel.value; apply(); });

      // read brand from URL (?b=apple)
      try {
        var p = new URLSearchParams(window.location.search).get('b');
        if (p) { brand = p.toLowerCase(); var target = $('[data-mcz-filter="' + brand + '"]', col); if (target) target.click(); }
      } catch (e) {}
      apply();
    });
  }

  /* ===========================================================
     8) RELATED products — native recommendations fetch, graceful fallback
     =========================================================== */
  function initRelated(root) {
    $all('[data-mcz-related]', root).forEach(function (sec) {
      if (sec.__mcz) return; sec.__mcz = true;
      var target = $('[data-mcz-rel-target]', sec);
      if (!target) return; // merchant-linked rail already rendered server-side
      var fallback = $('[data-mcz-rel-fallback]', sec);
      function useFallback() {
        if (target.parentNode) target.remove();
        if (fallback) fallback.hidden = false;
        else sec.style.display = 'none';
      }
      fetch(target.getAttribute('data-url'))
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var rail = doc.querySelector('[data-mcz-rel-products]');
          if (rail && rail.querySelector('[data-mcz-card]')) {
            target.replaceWith(rail);
            if (fallback) fallback.remove();
            init(rail); // bind hover/carousel on the injected cards
          } else useFallback();
        })
        .catch(useFallback);
    });
  }

  /* ===========================================================
     9) SCROLL-TO-TOP button
     =========================================================== */
  function initScrollTop() {
    var btn = document.querySelector('[data-mcz-scrolltop]');
    if (!btn || btn.__mcz) return; btn.__mcz = true;
    on(btn, 'click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    function upd() {
      var show = (window.pageYOffset || document.documentElement.scrollTop) > 400;
      btn.style.opacity = show ? '1' : '0';
      btn.style.pointerEvents = show ? 'auto' : 'none';
      btn.style.transform = show ? 'translateY(0)' : 'translateY(8px)';
    }
    on(window, 'scroll', upd, { passive: true }); upd();
  }

  /* ===========================================================
     PREDICTIVE SEARCH — header icon → overlay → /search/suggest.json
     =========================================================== */
  function initSearch(root) {
    var openBtn = $('[data-mcz-open-search]', root);
    var panel = document.getElementById('mcz-search');
    if (!panel) return;
    var input = panel.querySelector('[data-mcz-search-input]');
    var results = panel.querySelector('[data-mcz-search-results]');
    var statusEl = panel.querySelector('[data-mcz-search-status]');
    var allLink = panel.querySelector('[data-mcz-search-all]');
    function close() { toggleOverlay('mcz-search', false); }
    if (openBtn && !openBtn.__mcz) {
      openBtn.__mcz = 1;
      on(openBtn, 'click', function () { toggleOverlay('mcz-search', true); setTimeout(function () { if (input) input.focus(); }, 60); });
    }
    $all('[data-mcz-close-search], [data-mcz-close-search-scrim]', panel).forEach(function (b) { if (b.__mcz) return; b.__mcz = 1; on(b, 'click', close); });
    if (!panel.__mczEsc) { panel.__mczEsc = 1; on(document, 'keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); }); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function render(products, q) {
      if (!products || !products.length) { results.innerHTML = ''; statusEl.textContent = q ? 'No matches for “' + q + '”' : ''; if (allLink) allLink.style.display = 'none'; return; }
      results.innerHTML = products.map(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var pn = (p.price != null && p.price !== '') ? parseFloat(p.price) : NaN;
        var price = isNaN(pn) ? '' : formatMoney(Math.round(pn * 100));
        return '<a href="' + esc(p.url) + '" class="mcz-search-row">'
          + (img ? '<img src="' + esc(img) + '" width="52" height="52" loading="lazy" alt="">' : '')
          + '<span class="t"><b>' + esc(p.title) + '</b>'
          + (price ? '<span>' + price + '</span>' : '') + '</span></a>';
      }).join('');
      statusEl.textContent = products.length + ' result' + (products.length !== 1 ? 's' : '');
      if (allLink) { allLink.href = (allLink.getAttribute('data-base') || '/search') + '?q=' + encodeURIComponent(q) + '&type=product'; allLink.style.display = 'inline-flex'; }
    }
    var t;
    function run(q) {
      if (!q || q.length < 2) { results.innerHTML = ''; statusEl.textContent = ''; if (allLink) allLink.style.display = 'none'; return; }
      statusEl.textContent = 'Searching…';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) { var pr = (d && d.resources && d.resources.results && d.resources.results.products) || []; render(pr, q); })
        .catch(function () { statusEl.textContent = ''; });
    }
    if (input && !input.__mcz) {
      input.__mcz = 1;
      on(input, 'input', function () { clearTimeout(t); var q = input.value.trim(); t = setTimeout(function () { run(q); }, 250); });
    }
  }

  /* ===========================================================
     INIT
     =========================================================== */
  function init(root) {
    root = root || document;
    initHover(root);
    initCart(root);
    initMenu(root);
    initSearch(root);
    initScrollTop();
    initDeal(root);
    initScrims();
    initCarousels(root);
    initMobileOrder();
    initReveal(root);
    initTilt(root);
    initPDP(root);
    initCollection(root);
    initRelated(root);
  }
  window.__mczInit = init;

  // linked-options model dropdown → navigate to the sibling product
  document.addEventListener('change', function (e) {
    var nav = e.target.closest && e.target.closest('[data-mcz-lo-nav]');
    if (nav && nav.value) window.location.href = nav.value;
  });

  // ---- store-wide coupon: copying the code auto-applies it so it carries to checkout ----
  function mczApplyDiscount(code) {
    if (!code) return;
    try { localStorage.setItem('mcz-discount', code); } catch (e) {}
    // Canonical Shopify auto-apply: hitting /discount/<code> sets the discount
    // cookie for this session, so it's already applied at checkout — no manual paste.
    // The cookie rides on the 302 itself, so don't follow it (saves a full homepage
    // download per session) and never serve it from cache.
    try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual', cache: 'no-store' }); } catch (e) {}
  }
  window.__mczApplyDiscount = mczApplyDiscount;
  // Fail-safe: send checkout LINKS through the discount URL too (covers the case
  // where the background cookie didn't stick). Form submit buttons rely on the cookie.
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a[href^="/checkout"]');
    if (!el) return;
    var code = null; try { code = localStorage.getItem('mcz-discount'); } catch (er) {}
    if (!code) return;
    var dest = el.getAttribute('href') || '/checkout';
    e.preventDefault();
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Shopify theme editor: re-init on section load
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function () {});
})();
